import './App.css';
import About from './components/About';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
import { useState } from 'react'
import Alert from './components/Alert';
import Footer from './components/Footer';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";

function App() {
  const [mode, setmode] = useState('light');
  const [modetext, setModeText] = useState('Enable Dark-mode')
  const [alert, setAlert] = useState(null)

  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type
    })
    setTimeout(() => {
      setAlert(null);
    }, 1700)
  }


  const toggleMode = () => {

    if (mode === 'light') {
      setmode('dark')
      document.body.style.background = '#343536';
      setModeText('Enable Light-mode')
      showAlert("Darkmode has been enabled", "success")
    }
    else {
      setmode('light')
      document.body.style.background = 'white';
      setModeText('Enable Dark-mode')
      showAlert("Lightmode has been enabled", "success")

    }
  }
  return (
    <BrowserRouter>
      <Navbar title="TextHelper" mode={mode} toggleMode={toggleMode} modeText={modetext} />
      <Alert alert={alert} />
      <div className="container my-3">

        <Routes>
          <Route exact path="/about" element={<About mode={mode} />} />
          <Route exact path="/"

            element={<TextForm showAlert={showAlert} heading="Start typing, or copy and paste your document here" mode={mode} />
            }
          />
        </Routes>
      </div>
      <Footer mode={mode} />

    </BrowserRouter>
  );
}

export default App;
